import { format, parseISO } from 'date-fns';

/**
 * Formats an ISO date string to a user-friendly format
 * @param dateString ISO date string from backend (e.g., "2025-08-20T08:13:53.911704")
 * @param formatPattern Optional custom format pattern
 * @returns Formatted date string (e.g., "20-08-2025 01:43 PM")
 */
export const formatDateTime = (dateString: string, formatPattern: string = 'dd-MM-yyyy hh:mm a'): string => {
  try {
    // Parse the ISO string to a Date object
    const date = parseISO(dateString);
    // Format the date according to the specified pattern
    return format(date, formatPattern);
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateString; // Return original string if parsing fails
  }
};
